/* global  moment, _ */
import './style.less';
import courseTemplate from 'modals/assignCourse/template.html';
import courseController from 'modals/assignCourse/controller';
import { orderBy } from 'lodash';

export default function ($log, $stateParams, $filter, $uibModal, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.resultsQueried = false;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.pagination = {
    currentPage: 1,
    numPerPage: 15,
    setPage: pageNo => {
      vm.pagination.currentPage = pageNo;
    }
  };

  vm.toggleRow = item => (item.displayInfo = !item.displayInfo);

  vm.getters = {
    courseName: val => {
      return _.isEmpty(vm.courseDict[val.course_id]) ? 'Archived Course' : vm.courseDict[val.course_id].name;
    },
    courseCredits: val => {
      return _.isEmpty(vm.courseDict[val.course_id]) ? 0 : vm.courseDict[val.course_id].credits;
    },
    lastUpdated: val => {
      return moment(val.updated_at, 'x').unix();
    }
  };

  vm.headers = [
    { title: 'Last Updated', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1 ', sort: 'sortDate' },
    { title: 'Course', class: 'col-lg-4 col-md-4 col-sm-4 col-xs-4', sort: 'name' },
    { title: 'Credits', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
    { title: 'Status', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1 ', sort: 'status' },
    { title: 'Module Progress', class: 'col-lg-3 col-md-3 col-sm-3 col-xs-3 ', sort: 'modules_taeken' },
    { title: '', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' }
  ];

  vm.assignCourse = () => {
    $uibModal.open({
      template: courseTemplate,
      backdrop: true,
      size: 'lg',
      windowClass: 'modal',
      controller: courseController
    });
  };

  function activate() {
    $log.debug('Course Progress Component Activated');
    vm.loaded = false;
    vm.error = {};

    ApiClass.coursesGet(
      { courseType: false },
      {},
      {
        queryParams: {
          profile_uid,
          internal: true,
          vendor: true,
          filters: JSON.stringify({ requireProgress: true, includeExpired: true })
        }
      }
    )
      .then(({ data: { courses } }) => {
        const rawCourses = courses.map(course => {
          const progress = course.progress;
          progress.modules_total = progress.modules ? Object.keys(progress.modules).length : 1;
          const progressPercent = $filter('Progress')(progress.modules_taken, progress.modules_total);
          progress.progressBar = Number.isNaN(progressPercent) ? 0 : progressPercent;

          const { category_id, hours, credits, name, course_id } = course;
          if (!hours && category_id) progress.subject_area = course.subject_area;

          progress.sortDate = new Date(progress.updated_at).getTime();
          progress.credits = credits;
          progress.hours = hours;
          progress.name = name;
          progress.course_id = course_id;
          progress.status = $filter('Capitalize')(course.status);

          return progress;
        });
        vm.rawCourses = orderBy(rawCourses, ['sortDate'], ['desc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressCourses/controller.js